<template >
    <div class="errorPage">
        <div>
            <img src="../../assets/images/404.png" alt="">
            <p>数据错误</p>
        </div>
        
    </div>
</template>
<script>
export default {
    name:'error'
}
</script>
<style>
.errorPage{
    height: 100%;
    width: 100%;
    position: relative;
}
.errorPage>div{
         position: absolute;
    color: #999999;
    top: 50%;
    font-size: 0.26rem;
    text-align: center;
    left: 50%;
    margin-left: -1.75rem;
    margin-top: -1.75rem;
}
.errorPage>div>img{
    width: 3.5rem;
    margin-bottom: 0.2rem;

}
</style>





// WEBPACK FOOTER //
// src/components/error/error.vue